module.exports = __webpack_public_path__ + "img/5.0a067a0a.png";